// extracted by mini-css-extract-plugin
module.exports = {"cont":"NotFound_cont__3PpOD","box":"NotFound_box__MGBvo"};